import * as RoutePathConstants from '../../../constants/RoutePathConstants'
import cancelRecord from './views/cancel-record'
import createMakeAnAppointment from './views/create-make-an-appointment'

export default [
  {
    path: RoutePathConstants.CANCEL_RECORD,
    name: 'cancelRecord',
    component: cancelRecord
  },
  {
    path: RoutePathConstants.CREATE_MAKE_AN_APPOINTMENT,
    name: 'createMakeAnAppointment',
    component: createMakeAnAppointment
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/cancel-coupon/routers.js